<template>
  <div>
    <div
      v-if="isLoading"
    >
      <div class="loading-spinner">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
    </div>

    <div v-else>
      <!-- ปุ่มสำหรับเพิ่มแผนก -->
      <div class="btn-space">
        <b-button
          variant="primary"
          @click="showAddDeptModal"
        >
          {{ $t('addlist') }}
        </b-button>
      </div>
      <!-- Container สำหรับปุ่มค้นหาและปุ่มเพิ่ม -->
      <!-- ช่องค้นหาและปุ่มค้นหา -->
      <div class="search-filters">
        <b-form-group :label="$t('deptid')">
          <b-form-input
            v-model="search.deptId"
            :placeholder="$t('deptid')"
          />
        </b-form-group>

        <b-form-group :label="$t('deptname')">
          <b-form-input
            v-model="search.deptName"
            :placeholder="$t('deptname')"
          />
        </b-form-group>
        <b-button
          style="margin-top: 12px; background-color: #02a63e; color: white; border: none;"
          variant="text-warning"
          @click="searchDept(1)"
        >
          <b-icon
            icon="search"
            aria-hidden="true"
          />
          {{ $t('search') }}
        </b-button>
      </div>
    </div>

    <!-- Modal สำหรับเพิ่มแผนก -->
    <b-modal
      v-model="showAddModal"
      :title="$t('adddept')"
      hide-footer
    >
      <b-form @submit.prevent="addDept">
        <b-form-group :label="$t('deptid')">
          <b-form-input
            v-model="newDept.deptId"
            maxlength="50"
            required
          />
        </b-form-group>
        <b-form-group :label="$t('deptname')">
          <b-form-input
            v-model="newDept.dept"
            maxlength="50"
            required
          />
        </b-form-group>
        <b-button
          type="submit"
          variant="primary"
        >
          {{ $t('submit') }}
        </b-button>
      </b-form>
    </b-modal>

    <!-- Modal สำหรับแก้ไขแผนก -->
    <b-modal
      v-model="showEditModal"
      :title="$t('editdept')"
      hide-footer
    >
      <b-form @submit.prevent="updateDept">
        <b-form-group :label="$t('editdept')">
          <b-form-input
            v-model="editDept.deptId"
            maxlength="50"
            required
          />
        </b-form-group>
        <b-form-group :label="$t('deptname')">
          <b-form-input
            v-model="editDept.dept"
            maxlength="50"
            required
          />
        </b-form-group>
        <b-button
          type="submit"
          variant="success"
        >
          {{ $t('submit') }}
        </b-button>
      </b-form>
    </b-modal>

    <!-- ตารางแสดงแผนก -->
    <b-table
      v-if="!isLoading && totalDept > 0"
      :items="dept"
      :fields="fields"
      class="dept-table"
    >
      <template #cell(deptId)="data">
        {{ data.item.deptId || '' }}
      </template>
      <template #cell(dept)="data">
        {{ data.item.dept || '' }}
      </template>
      <template #cell(actions)="data">
        <b-button
          class="b-btn"
          variant="warning"
          size="sm"
          @click="showEditDeptModal(data.item)"
        >
          {{ $t('edit') }}
        </b-button>

        <b-button
          class="b-btn"
          variant="danger"
          size="sm"
          @click="prepareDelete(data.item.id)"
        >
          {{ $t('delete') }}
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!isLoading && totalDept === 0"
      class="text-center mt-3"
    >
      <p style="font-size: 28px; font-weight: bold;">
        {{ $t('nodeptdetails') }}
      </p>
    </div>

    <div
      v-if="!isLoading && totalDept > 0"
      class="d-flex justify-content-end mt-3"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="totalDept"
        :per-page="itemsPerPage"
        class="mt-3"
        @change="handlePageChange"
      />
    </div>

    <!-- Confirmation Modal -->
    <b-modal
      v-model="showConfirmationModal"
      :title="$t('delconfirm')"
      :ok-title="$t('yes')"
      :cancel-title="$t('cancel')"
      @ok="confirmDelete"
    >
      <p class="my-4">
        {{ $t('confirmdelete') }}
      </p>
    </b-modal>
  </div>
</template>

<script>
import apiSetting from '@/services/Setting'

export default {
  data() {
    return {
      dept: [],
      isAdmin: false,
      activeFilter: '',
      search: {
        deptId: '',
        deptName: '',
      },
      newDept: {
        deptId: '',
        dept: '',
      },
      editDept: {
        id: null,
        deptId: '',
        dept: '',
      },
      showAddModal: false,
      showEditModal: false,
      showConfirmationModal: false,
      itemToDelete: null,
      isLoading: true,
      currentPage: 1,
      itemsPerPage: 5,
      totalDept: 0,
      totalPages: 0,
    }
  },
  computed: {
    fields() {
      return [
        { key: 'deptId', label: this.$t('deptid'), sortable: true },
        { key: 'dept', label: this.$t('deptname'), sortable: true },
        { key: 'actions', label: this.$t('management'), sortable: true },
      ]
    },
  },
  created() {
    this.initialize()
  },
  methods: {

    prepareDelete(itemId) {
      this.itemToDelete = itemId
      this.showConfirmationModal = true
    },
    async handlePageChange(page) {
      this.currentPage = page // ตั้งค่า currentPage ใหม่
      await this.searchDept(this.currentPage)
    },
    // ดำเนินการลบหลังจากการยืนยัน
    async confirmDelete() {
      if (this.itemToDelete) {
        try {
          await apiSetting.delete(`/deptDel/${this.itemToDelete}`)
          this.$emit('delete-success')
          await this.fetchdept() // รีเฟรชข้อมูลหลังจากลบ
        } catch (error) {
          const errorMessage = error.response ? error.response.data : error.message
          console.error('Error deleting department:', errorMessage)

          // แสดง Toast ข้อความผิดพลาด
          this.$bvToast.toast(this.$t('useddelete'), {
            title: this.$t('error'),
            variant: 'danger',
            solid: true,
            appendToast: true,
            autoHideDelay: 5000,
            toaster: 'b-toaster-top-right',
          })
        }
        this.itemToDelete = null
      }
      this.showConfirmationModal = false
    },

    async initialize() {
      await this.fetchdept()
    },
    showAddDeptModal() {
      this.newDept = {
        deptId: '',
        dept: '',
      }
      this.showAddModal = true
    },
    async addDept() {
      try {
        await apiSetting.post('/deptAdd', this.newDept)
        this.showAddModal = false
        await this.fetchdept() // รีเฟรชข้อมูลหลังจากเพิ่ม
      } catch (error) {
        console.error('Error adding department:', error.response ? error.response.data : error.message)
      }
    },
    showEditDeptModal(dept) {
      this.editDept = { ...dept }
      this.showEditModal = true
    },
    async updateDept() {
      try {
        await apiSetting.put(`/deptUpdate/${this.editDept.id}`, this.editDept)
        this.showEditModal = false
        await this.fetchdept() // รีเฟรชข้อมูลหลังจากแก้ไข
      } catch (error) {
        console.error('Error updating department:', error.response ? error.response.data : error.message)
      }
    },

    async searchDept(page = 1) {
      this.isLoading = true
      try {
        if (!this.search.deptId && !this.search.deptName) {
          await this.fetchdept(page)
          return
        }
        this.currentPage = page
        const params = {
          page: page - 1,
          size: this.itemsPerPage,
        }

        if (this.search.deptId) {
          params.deptId = this.search.deptId
        }
        if (this.search.deptName) {
          params.deptName = this.search.deptName
        }

        const response = await apiSetting.get('/dept/search', { params })
        this.dept = response.data.content
        this.totalDept = response.data.totalElements
        this.totalPages = response.data.totalPages
      } catch (error) {
        console.error('Error fetching dept:', error.response ? error.response.data : error.message)
        this.dept = []
        this.totalDept = 0
        this.totalPages = 0
      } finally {
        this.isLoading = false
      }
    },

    async fetchdept() {
      this.isLoading = true
      try {
        const params = {
          page: this.currentPage - 1, // API uses 0-based indexing
          size: this.itemsPerPage,
        }

        const response = await apiSetting.get('/deptList', { params })
        console.log('Fetched dept:', response.data.content)
        this.dept = response.data.content

        this.totalDept = response.data.totalElements
        this.totalPages = response.data.totalPages
      } catch (error) {
        console.error('Error fetching dept:', error.response ? error.response.data : error.message)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.listdata {
  font-size:x-small;
  margin: 0.5%;
}

.container {
  display: flex;
  justify-content: space-between; /* จัดตำแหน่งปุ่มทางซ้ายและขวา */
  align-items: center; /* จัดตำแหน่งแนวตั้ง */
  margin-bottom: 1rem; /* กำหนดระยะห่างจากเนื้อหาด้านล่าง */
}

.clickable-icon {
  cursor: pointer; /* เปลี่ยนเคอร์เซอร์เป็นมือเมื่อชี้ที่ไอคอน */
  margin-right: 10px; /* เพิ่มระยะห่างระหว่างไอคอน */
  margin-bottom: 5px;
}
.icon-large {
  font-size: 24px; /* กำหนดขนาดไอคอน (ปรับตามต้องการ) */
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.multiline-text {
  white-space: nowrap; /* Force single line display */
  overflow: hidden;
  text-overflow: ellipsis; /* Add ellipsis if text is too long */
  font-size:x-small;
}

.search-filters {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.search-input {
  width: 300px; /* Adjust the width as needed */
}

.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #5496ec;
  animation: bounce 0.6s infinite alternate;
}

.b-btn {
  margin-right: 10px;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-20px);
  }
}

.btn-space {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap; /* เพื่อให้ปุ่มเลื่อนลงมาในกรณีที่พื้นที่ไม่พอ */
}

.dept-table thead {
    display: none; /* ซ่อนหัวตาราง */
  }

  @media (max-width: 768px) {
  .dept-table {
    display: block; /* เปลี่ยนตารางให้เป็น block */
    overflow-x: auto; /* เพิ่มแถบเลื่อนแนวนอน */
  }
  .btn-space {
    justify-content: center; /* จัดตำแหน่งปุ่มไปที่กลาง */
  }

  .btn-space b-button {
    flex: 1 1 100%; /* ทำให้ปุ่มเต็มความกว้าง */
    margin-bottom: 0.5rem; /* เว้นระยะห่างระหว่างปุ่ม */
  }
  .listdata {
    font-size: 0.9rem; /* ลดขนาดฟอนต์ให้เหมาะสมกับหน้าจอเล็ก */
  }

}
</style>
